import { BUSINESS_UNIT } from '@/constants/businessUnit'

/**
 * Actions is a relation between an User Interaction and the Role that the user need to be to do that interaction
 * You can find the roles available in the permissionsDictionary file
 */
const Actions = Object.freeze({
  CREATE_USER: 'CREATE_USER',
  CREATE_EXCLUSIVE_EVENT: 'CREATE_EXCLUSIVE_EVENT',
  EDIT_STATUS_BASIC: 'EDIT_STATUS_BASIC',
  EDIT_STATUS_BLOCKED: 'EDIT_STATUS_BLOCKED',
  EDIT_STATUS_MIGRATED: 'EDIT_STATUS_MIGRATED',
  EDIT_STATUS_BLOCKED_FRAUD: 'EDIT_STATUS_BLOCKED_FRAUD',
  LIST_USERS: 'LIST_USERS',
  LIST_EXTRACT: 'LIST_EXTRACT',
  LIST_CAMPAIGNS: 'LIST_CAMPAIGNS',
  LIST_ACCELERATIONS: 'LIST_ACCELERATIONS',
  CREATE_ACCELERATION: 'CREATE_ACCELERATION',
  EDIT_ACCELERATION: 'EDIT_ACCELERATION',
  LIST_ACCELERATION: 'LIST_ACCELERATION',
  SELECT_STATUS_BLOCKED: 'SELECT_STATUS_BLOCKED',
  SELECT_STATUS_MIGRATED: 'SELECT_STATUS_MIGRATED',
  UPDATE_POINTS: 'UPDATE_POINTS',
  UPDATE_POINTS_UNLIMITED: 'UPDATE_POINTS_UNLIMITED',
  ANONYMIZE: 'ANONYMIZE',
  DOWNLOAD_LOGS: 'DOWNLOAD_LOGS',
  REGISTER_CONTACT_INFO: 'REGISTER_CONTACT_INFO',
  SEE_POINTS_REPORT: 'SEE_POINTS_REPORT',
  UPDATE_REGISTER_DATA: 'UPDATE_REGISTER_DATA',
  LIST_BENEFITS_EVENTS: 'LIST_BENEFITS_EVENTS'
})

const getActionsByBusinessUnit = (businessUnit) => {
  const defaultActions = {
    [Actions.CREATE_USER]: [1],
    [Actions.LIST_USERS]: [1, 2, 3, 4, 5],
    [Actions.EDIT_STATUS_BASIC]: [1, 2, 3, 4],
    [Actions.SELECT_STATUS_MIGRATED]: [1, 2],
    [Actions.SELECT_STATUS_BLOCKED]: [1, 2, 4],
    [Actions.EDIT_STATUS_MIGRATED]: [],
    [Actions.EDIT_STATUS_BLOCKED]: [1, 2, 4],
    [Actions.EDIT_STATUS_BLOCKED_FRAUD]: [1, 4],
    [Actions.LIST_CAMPAIGNS]: [1, 2],
    [Actions.LIST_ACCELERATIONS]: [1, 2, 3, 4, 5],
    [Actions.CREATE_ACCELERATION]: [1, 2],
    [Actions.EDIT_ACCELERATION]: [1, 2],
    [Actions.LIST_ACCELERATION]: [1, 2, 3, 4, 5],
    [Actions.SEE_POINTS_REPORT]: [1, 2],
    [Actions.ANONYMIZE]: [1, 2],
    [Actions.UPDATE_REGISTER_DATA]: [1, 2, 3, 4],
    [Actions.REGISTER_CONTACT_INFO]: [1, 2, 3],
    [Actions.LIST_EXTRACT]: [1, 2, 3, 4, 5],
    [Actions.UPDATE_POINTS]: [1, 2, 3],
    [Actions.UPDATE_POINTS_UNLIMITED]: [1, 2],
    [Actions.DOWNLOAD_LOGS]: [1, 2],
    [Actions.CREATE_EXCLUSIVE_EVENT]: [1, 2],
    [Actions.LIST_BENEFITS_EVENTS]: [1, 2]
  }
  if (businessUnit == BUSINESS_UNIT.GBPT) {
    return {
      ...defaultActions,
      [Actions.CREATE_USER]: [1],
      [Actions.EDIT_STATUS_BASIC]: [1, 3],
      [Actions.SELECT_STATUS_MIGRATED]: [1],
      [Actions.SELECT_STATUS_BLOCKED]: [1],
      [Actions.EDIT_STATUS_BLOCKED]: [1],
      [Actions.LIST_CAMPAIGNS]: [1],
      [Actions.LIST_ACCELERATIONS]: [1],
      [Actions.CREATE_ACCELERATION]: [1],
      [Actions.EDIT_ACCELERATION]: [1],
      [Actions.LIST_ACCELERATION]: [1],
      [Actions.SEE_POINTS_REPORT]: [1],
      [Actions.ANONYMIZE]: [1, 2, 3, 4],
      [Actions.UPDATE_REGISTER_DATA]: [1, 3],
      [Actions.REGISTER_CONTACT_INFO]: [1],
      [Actions.UPDATE_POINTS_UNLIMITED]: [1],
      [Actions.DOWNLOAD_LOGS]: [1],
      [Actions.LIST_BENEFITS_EVENTS]: [1]
    }
  }
  return defaultActions
}

export { Actions, getActionsByBusinessUnit }
